<template>
  <!-- 列表弹出框 -->
  <div>
    <van-popup
      class="box"
      v-model="show"
      position="bottom"
      :style="{ height: '65%' }"
    >
      <div class="header">
        <span class="title">{{ header }}</span>

        <img src="../../../../assets/refund/down.png" alt="" @click="close">
      </div>
      <div class="header_down">
        仅提供在退货申请日期前45天出发的跟团行程单
      </div>
      <div class="person-list">
        <div
          v-for="(item, index) of datalist"
          :key="index"
          class="person-item"
          :class="radioIndex === index  ? 'item-select' : ''"
          @click="selectItem(item, index)"
        >
          <div class="body">
            <p class="title">{{item.route_name}}</p>
            <table>
              <tr>
                <td>行程单号：</td>
                <td>{{item.team_id}}</td>
              </tr>
              <tr>
                <td>旅行社：</td>
                <td>{{item.name}}</td>
              </tr>
              <tr>
                <td>出行时间：</td>
                <td>{{item.team_start_date | dateFilter}}</td>
              </tr>
            </table>

          </div>
          <div>
            <p class="radio" :class="radioIndex === index  ? 'select' : ''"><span></span></p>
          </div>
        </div>
        <!-- 以上都不是 -->
        <div @click="not" class="person-item" :class="radioIndex === -1  ? 'item-select' : ''">
          <div class="body">
            <p class="title">以上都不是</p>
            <table>
              <tr>
                <td>需上传相关行程订单截图、照片等 <span style="color: red;">*</span></td>
              </tr>
            </table>
          </div>
        </div>
        <div class="foot">
          <button @click="close()" type="submit">确定</button>
        </div>
      </div>
      <!-- <div class="box1">
        <img src="../../../../assets/empty/ic_wuxingxi.png" />
        <p class="tip1">暂无数据</p>
      </div> -->
    </van-popup>
  </div>
</template>
<script>
    import api from '../../../../service/modules/refund'

    export default {
        filters: {
            // 截取时间
            dateFilter (val) {
                return val.substr(0, 10)
            }
        },
        props: ['datalist', 'header'],
        data () {
            return {
                selItem: {},
                show: false,
                radioIndex: 5
            }
        },
        methods: {
            //  选择‘以上都不是’
            not () {
                this.radioIndex = -1
                this.$emit('select', -1)
            },
            init (item) {
                this.show = true
                if (item) {
                    this.selItem = item
                }
            },
            // 点击列表项
            selectItem (item, index) {
                this.radioIndex = index
                this.selItem = item
                this.$emit('select', this.selItem)
                // this.close()
            },
            close () {
                if (this.radioIndex === -1) {
                    this.$emit('close', -1)
                } else {
                    this.$emit('close', this.selItem)
                }
                this.show = false
            }
        }
    }
</script>

<style lang="less" scoped>
  .box {
    padding: 0 16px;
    .header {
      padding: 20px 0 13px;
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 16px;
        color: #171a1d;
        font-weight: 600;
      }
      img{
        width: 16px;
        height: 16px;
      }
    }
    .header_down{
      color: #666666;
      font-size: 12px;
      margin-bottom: 20px;
    }
    .tab-box {
      display: flex;
      border-bottom: 1px solid #f5f6f9;
      padding-top: 11px;
      .tab {
        margin-right: 21px;
        font-size: 14px;
        color: #666666;
        padding-bottom: 14.5px;
      }
      .tab-active {
        margin-right: 21px;
        font-size: 14px;
        color: #171a1d;
        padding-bottom: 14.5px;
        border-bottom: 1px solid #36b374;
      }
    }

    .person-list {
      max-height: 350px;
      overflow: auto;
      padding-bottom: 90px;
      &::-webkit-scrollbar {
        display: none;
      }
      .person-item {
        background: #F7F7F7;
        border-radius: 2px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 19px;
        padding: 14px 16px 11px;
        .body{
          .title{
            color: #333333;
            font-size: 16px;
            line-height: 22px;
          }
          table{
            color: #999999;
            font-size: 12px;
            line-height: 17px;
            tr{
              margin-bottom: 6px;
            }
          }
        }
        .radio{
          display: block;
          width: 18px;
          height: 18px;
          box-sizing: border-box;
          border: 1px solid #A2A3A4;
          border-radius: 50%;
        }
        .select{
          border: 1px solid #36B374;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          span{
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #36B374;
          }
        }

      }
      .item-select {
        border: 1px solid #36B374;
      }
      .foot{
            bottom: 0;
          position: fixed;
          width: 92%;
          background: white;
          padding-bottom: 34px;
        button{
          background-color: #36B374;
          width: 100%;
          font-size: 16px;
          color: #ffffff;
          text-align: center;
          line-height: 48px;
          border-radius: 4px;
          border: 0;
        }
      }
    }
    .box1 {
      text-align: center;
      margin-top: 64px;
      padding-bottom: 87px;
      img {
        display: inline-block;
        width: 74px;
        height: 62px;
      }
      .tip1 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 24px;
      }
      .tip2 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 8px;
      }
    }
  }
</style>
